export const GET_EMPLOYEES = 'getAllEmployees';
export const GET_ALL_EMPLOYEES = `${GET_EMPLOYEES}/getAllEmployees`;
export const GET_ALL_EMPLOYEES_SUCCESS = `${GET_EMPLOYEES}/getAllEmployeesSuccess`;
export const GET_ALL_EMPLOYEES_FAILURE = `${GET_EMPLOYEES}/getAllEmployeesFailure`;
